export enum MboPermissions {
  Mbo = 'mbo',
}
